export default __webpack_public_path__ + "4360fe00693c8efd39e6628695759a02.svg";